import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createGetDataThunk, createInitialProcDataState } from '../../common/procSliceCommons'
import { convertToGraphData, transposeData } from '../../common/transposeData';
import { MonitorState } from './monitorStore';
import { IProcHeader } from '../../data/Procedure';
import { calculateStateParameters } from '../run/sliceRunProcHeader';
import { DeltaPFCalculator, DeltaPFPulmonaryVeinCalculator, ISetFieldPayload, PerfusateLostCalculator, PVResistanceCalculator } from '../run/sliceTimeline';

export const getProcDataAsync = createGetDataThunk('monitorData/fetchProcData')
const initialState = createInitialProcDataState();

export const dataSlice = createSlice({
    name: 'monitorData',
    initialState: initialState,
    reducers: {
        setHeader: (state, action: PayloadAction<IProcHeader>) => {
            state.timelineData = { ...state.timelineData, [action.payload.step]: action.payload }
            calculateStateParameters(action.payload)
        },

        setfield: (state, action: PayloadAction<ISetFieldPayload>) => {

            state.timelineData[action.payload.step][action.payload.fieldName] = action.payload.value

            state.timelineData[action.payload.step].PVResistance = 
                PVResistanceCalculator(state.timelineData[action.payload.step], action.payload.fieldName) 
                    ?? state.timelineData[action.payload.step].PVResistance

            state.timelineData[action.payload.step].PerfusateLoss = PerfusateLostCalculator(
                state.timelineData, 
                action.payload.step, 
                action.payload.fieldName)
                    ?? state.timelineData[action.payload.step].PerfusateLoss

            state.timelineData[action.payload.step].DeltaPF = 
                DeltaPFCalculator(state.timelineData[action.payload.step], action.payload.fieldName)
                    ?? state.timelineData[action.payload.step].DeltaPF
            
            state.timelineData[action.payload.step].DeltaPFRUV 
                = DeltaPFPulmonaryVeinCalculator('RUVPO2',state.timelineData[action.payload.step], action.payload.fieldName) 
                    ?? state.timelineData[action.payload.step].DeltaPFRUV

            state.timelineData[action.payload.step].DeltaPFRLV 
                = DeltaPFPulmonaryVeinCalculator('RLVPO2',state.timelineData[action.payload.step], action.payload.fieldName ) 
                    ?? state.timelineData[action.payload.step].DeltaPFRLV

            state.timelineData[action.payload.step].DeltaPFLUV 
                = DeltaPFPulmonaryVeinCalculator('LUVPO2',state.timelineData[action.payload.step], action.payload.fieldName )
                    ?? state.timelineData[action.payload.step].DeltaPFLUV

            state.timelineData[action.payload.step].DeltaPFLLV 
                = DeltaPFPulmonaryVeinCalculator('LLVPO2',state.timelineData[action.payload.step], action.payload.fieldName )
                    ?? state.timelineData[action.payload.step].DeltaPFLLV
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProcDataAsync.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getProcDataAsync.fulfilled, (state, action) => {
                state.status = 'idle';
                state.timelineData = action.payload!
                state.transposed = transposeData(action.payload!)
                state.chartData = convertToGraphData(action.payload!)
            })
    }
})

export const selectData = (state: MonitorState) => state.dataSlice.timelineData
export const selectTransposed = (state: MonitorState) => state.dataSlice.transposed
export const selectChartData = (state: MonitorState) => state.dataSlice.chartData
export const selectStatus = (state: MonitorState) => state.dataSlice.status

export const { setfield, setHeader } = dataSlice.actions


export default dataSlice.reducer
